import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { AuthDispatch } from '@state/auth/auth.dispatch';
import { Observable } from 'rxjs';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { envTypes } from 'src/environments/env.types';
import { environment } from 'src/environments/environment';
import { TestHooks } from './login.hooks';
import { LoginSelector } from './login.selector';
import { AppDispatch } from '@state/app/app.dispatch';

enum USER_CREDENTIALS {
	EMAIL = 'email',
	PASSWORD = 'password',
}

@UntilDestroy()
@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LoginComponent implements OnInit {
	@Select(LoginSelector.getLoginLoading) loginLoading$: Observable<boolean>;
	forgetUrl = UrlService.Forgot();
	signUpUrl = UrlService.SignUp();
	USER_CREDENTIALS = USER_CREDENTIALS;
	testHooks = TestHooks;

	authForm = this.fb.group({
		[USER_CREDENTIALS.EMAIL]: this.fb.control(
			environment.env === envTypes.DEVELOPMENT
				? environment.website.test.email
				: (localStorage.getItem('loginEmail') ?? ''),
			[Validators.required, Validators.email],
		),
		[USER_CREDENTIALS.PASSWORD]: this.fb.control(
			environment.env === envTypes.DEVELOPMENT
				? environment.website.test.password
				: '',
			[Validators.required],
		),
	});

	constructor(
		private authDispatch: AuthDispatch,
		private fb: FormBuilder,
		private appDispatch: AppDispatch,
	) {}

	ngOnInit(): void {
		this.appDispatch.SetLoadedFromLeap(false);
		this.authDispatch.LogOut();
	}

	submit(): void {
		this.authForm.markAllAsTouched();
		if (this.authForm.valid) {
			const { email, password } = this.authForm.value;
			this.authDispatch.LoginWithEmailAndPassword(email, password);
		}
	}
}
